// extracted by mini-css-extract-plugin
export var cardHeader = "_go-1";
export var contentCard = "_go-0";
export var headerActions = "_go-3";
export var reorderHandle = "_go-5";
export var titleArea = "_go-2";
export var titleAreaWithHandle = "_go-4";